import {Component, Input} from '@angular/core';
import {Observable} from "rxjs";

@Component({
  selector: 'pt-image-with-link',
  template: `
    <div class="image-with-link">
      <img src="{{image}}" alt="Image">
      <p class="w-">{{text}}</p>
      <a *ngFor="let l of links" href="{{l.link}}" ngbTooltip="{{l.tooltip | async}}">
        <img src="{{l.image}}" alt="Image">
      </a>
    </div>
  `,
  styles: [`
    .image-with-link {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 0;
    }
    .image-with-link img {
      width: 32px;
      padding: 5px;
    }

    .image-with-link p {
      text-align: left;
      margin: 0;
      padding: 5px;
      width: calc(100% - 40px);
    }
    .image-with-link a {
      text-align: left;
      margin: 0;
      padding: 0 5px;
    }
  `]
})
export class ImageWithLinkComponent {
  @Input() image: string;
  @Input() text: string;
  @Input() links: ImageWithLink[];
}

export interface ImageWithLink {
  image: string;
  link: string;
  tooltip?: Observable<string>;
}
